export default __webpack_public_path__ + "static/media/banner-ja-baixou-o-app.3c5777c4.png";